import { CircleHelpIcon } from "lucide-react";

import { Tooltip, TooltipPopup, TooltipTrigger } from "~/components/ui/tooltip";
import { cn } from "~/lib/utils";

export function SettingsInfoTip(props: { className?: string; label: string }) {
  return (
    <Tooltip>
      <TooltipTrigger
        type="button"
        aria-label={props.label}
        className={cn(
          "inline-flex size-4 shrink-0 items-center justify-center rounded-full text-muted-foreground transition-colors hover:text-foreground",
          props.className,
        )}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
        }}
      >
        <CircleHelpIcon className="size-3.5" />
      </TooltipTrigger>
      <TooltipPopup side="top" className="max-w-64 text-xs leading-relaxed">
        {props.label}
      </TooltipPopup>
    </Tooltip>
  );
}
